import { createSlice } from "@reduxjs/toolkit";
import { reKyc_AccountClosureThunk } from "./thunk";

export const initialState = {
  reKyc_AccountClosureData: [],
  reKyc_AccountClosureError: "", // for error message
  reKyc_AccountClosureLoading: false,
};

const Re_Kyc_Account_Closure = createSlice({
  name: "Re_Kyc_Account_Closure",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(reKyc_AccountClosureThunk.pending, (state) => {
      state.reKyc_AccountClosureLoading = true;
      state.reKyc_AccountClosureData = [];
      state.reKyc_AccountClosureError = "";
    });
    builder.addCase(reKyc_AccountClosureThunk.fulfilled, (state, action) => {
      state.reKyc_AccountClosureData = action.payload.data;
      state.reKyc_AccountClosureLoading = false;
    });
    builder.addCase(reKyc_AccountClosureThunk.rejected, (state, action) => {
      state.reKyc_AccountClosureError =
        action.error?.message ||
        action.payload?.message ||
        "An unknown error occurred";
      state.reKyc_AccountClosureLoading = false;
    });
  },
});

export const { apiRequest, apiError } = Re_Kyc_Account_Closure.actions;

export default Re_Kyc_Account_Closure.reducer;
